import { css } from '@emotion/react';
import { ButtonProps, Button as SparkButton } from '@spark-web/button';
import { Text } from '@spark-web/text';
import { ThemeProvider } from '@spark-web/theme';
import { forwardRef } from 'react';

import { usePartnerConfig } from '~/context/PartnerConfigContext';
import { toSparkTheme } from '~/utils/theme';

export const Button = forwardRef(({ children, ...buttonProps }: ButtonProps, ref) => {
  const config = usePartnerConfig();

  const theme = toSparkTheme(config?.configuration?.sparkThemeName);
  return (
    <ThemeProvider theme="brighte">
      {/* overriding theme causes button text to use the theme's text which causes ui discrepancy. Had to wrap the text in a theme provider to fix this. */}
      {/* @ts-expect-error Spark-web button only accepts icon/string as children so passing JSX element as children will fail in typescript */}
      <SparkButton {...buttonProps} ref={ref}>
        <ThemeProvider theme={theme}>
          <Text
            size="small"
            weight={theme === 'brighte' ? 'semibold' : 'regular'}
            css={css({ alignItems: 'center', display: 'flex' })}
          >
            {children}
          </Text>
        </ThemeProvider>
      </SparkButton>
    </ThemeProvider>
  );
});

Button.displayName = 'BrighteButton';
